<template>
    <div class="tw-flex tw-gap-2">
        <a href="/" class="tw-self-center">
            <img
                :src="src"
                :class="`${props.class ? props.class : 'tw-h-12 tw-w-36'}`"
                :width="width"
                :height="height"
                alt="Logo"
                v-if="src"
            />
            <img
                :src="
                    settings && settings.contacts?.logo_path
                        ? settings.contacts?.logo_path
                        : '/img/logo.svg'
                "
                alt="logo"
                :class="`${props.class ? props.class : 'tw-h-12 tw-w-12'}`"
                :width="width"
                :height="height"
                v-else
            />
        </a>
        <div
            v-if="partnersPathLogo"
            class="tw-self-center tw-text-4xl tw-text-gray-300"
        >
            +
        </div>
        <a
            v-if="partnersPathLogo"
            :href="partnerUrl || undefined"
            :target="partnerUrl ? '_blank' : undefined"
            :rel="partnerUrl ? 'noopener noreferrer' : undefined"
            class="tw-self-center"
        >
            <img
                :src="partnersPathLogo"
                alt="logo"
                :class="`${props.class ? props.class : 'tw-h-12 tw-w-auto'}`"
                :width="width"
                :height="height"
                @error="partnerLogoError = true"
            />
        </a>
    </div>
</template>

<script setup lang="ts">
/**
 *
 *  Props and emits section
 *
 *
 */

const props = withDefaults(
    defineProps<{
        height?: string
        width?: string
        class?: string
        src?: string
        partnerMode?: boolean
        partnerAltLogo?: boolean
    }>(),
    {
        partnerMode: true,
        partnerAltLogo: false,
    }
)

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

const contactsStore = useDefaultSettingsStore()
const { settings } = storeToRefs(contactsStore)

const payFormCookie = useCookie<string | null>("pay_form_filter")
const { data: partners } = await usePartners()
const { activePartner } = usePartnerBranding()

const partnerLogoError = ref(false)
watch(
    () => payFormCookie.value,
    () => {
        partnerLogoError.value = false
    }
)

const partnersPathLogo = computed(() => {
    if (!props.partnerMode || !partners.value) return null

    const partner = partners.value?.data?.find(
        (p) => p.slug === activePartner.value?.slug
    )

    if (!partner) return null

    if (props.partnerAltLogo && activePartner.value?.logoAlt) {
        return activePartner.value.logoAlt
    }

    if (activePartner.value?.logo) {
        return activePartner.value.logo
    }

    if (payFormCookie.value && !partnerLogoError.value) {
        return `/img/partners/${payFormCookie.value}.png`
    }

    return null
})

const partnerUrl = computed(() => {
    if (!payFormCookie.value) return null
    return (
        partners.value?.data?.find((p) => p.slug === payFormCookie.value)
            ?.url ?? null
    )
})

watch(
    () => partners.value?.data,
    (list) => {
        if (!list || !payFormCookie.value) return
        const exists = list.some((p) => p.slug === payFormCookie.value)
        if (!exists) payFormCookie.value = null
    },
    { immediate: true }
)

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */
</script>
